<!-- Dialog: FILTER NEW-->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-warning"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>
  <div fxLayout="row" fxLayoutAlign="start">{{data.dialogData.message}}</div>
  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionDeleteFilter_close()"
      label="No"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary-bold"
      (click)="actionDeleteFilter_confirm()"
      label="Yes"
    ></button>
  </p-footer>
</p-dialog>
